import React from 'react';
import { Button } from './components/ui/button';
import { BookOpen, PenTool } from 'lucide-react';

export default function WelcomeScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 via-white to-slate-100/30 p-4">
      <div className="w-full max-w-md text-center">
        {/* Logo */}
        <div className="mb-6 flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-slate-500 to-teal-600 shadow-lg">
            <BookOpen className="h-10 w-10 text-white" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-slate-900">Welcome to Narratoria</h1>
        <p className="mt-2 text-slate-500">Your home for advance reader copies and indie publishing</p>

        {/* Role picker */}
        <div className="mt-8 space-y-3">
          <Button
            className="w-full gap-2 bg-teal-600 py-6 text-base font-semibold text-white hover:bg-teal-700"
            onClick={() => { window.location.href = '/reader'; }}
          >
            <BookOpen className="h-5 w-5" />
            I am here to read
          </Button>

          <Button
            variant="outline"
            className="w-full gap-2 border-slate-300 py-6 text-base font-semibold text-slate-700 hover:border-teal-300 hover:text-teal-700"
            onClick={() => { window.location.href = '/author/signup'; }}
          >
            <PenTool className="h-5 w-5" />
            I am here to publish
          </Button>
        </div>

        <p className="mt-6 text-sm text-slate-400">
          You can do both. Just pick your main reason for joining and you can add the other later.
        </p>

        {/* Existing account */}
        <div className="mt-8 border-t border-slate-200 pt-6">
          <p className="text-sm text-slate-500">
            Already have an account?{' '}
            <a href="/author/login" className="font-medium text-teal-600 hover:text-teal-700">Sign in</a>
          </p>
        </div>
      </div>
    </div>
  );
}
